import styled from 'styled-components'

export const Container = styled.div``

export const ContainerButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: flex-end;
	align-items: flex-end;
	flex-direction: column;
	margin-top: 62px;

	p {
		margin: 0;
		padding: 12px 0;
	}

	button {
		margin: 0;
	}

	@media (max-width: 768px) {
		align-items: center;
	}
`
